import PropTypes from 'prop-types';
import React from 'react';

import { RichTextEditor } from '@/design-system/atoms/RichTextEditor';
import { StarRatings } from '@/design-system/atoms/StarRatings';
import { Text } from '@/design-system/atoms/Text';

import styles from '../../BioReviews.module.scss';

const Review = ({ overallRating, mentionTime, comment, ...props }) => {
    const submissionDate = React.useMemo(() => {
        if (!mentionTime) return '';
        const date = new Date(mentionTime);
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        };
        return date.toLocaleDateString('en-US', options);
    }, [mentionTime]);

    return (
        <div className={styles[`bio-reviews__review`]} {...props}>
            <div className={styles[`bio-reviews__review-header`]}>
                {typeof overallRating?.value === 'number' && overallRating?.value > 0 && (
                    <div className={styles[`bio-reviews__review-stars`]}>
                        <StarRatings total={5} ratings={overallRating?.value} />
                        <Text
                            tag="div"
                            variant={Text.VARIANT.E1}
                            content={`${overallRating?.value.toFixed(1)}`}
                            className={styles[`bio-reviews__review-rating`]}
                        />
                    </div>
                )}
                {mentionTime && (
                    <Text
                        tag="div"
                        variant={Text.VARIANT.T3}
                        content={`${submissionDate}`}
                        className={styles[`bio-reviews__review-date`]}
                    />
                )}
            </div>
            {comment && (
                <div className={styles[`bio-reviews__review-text`]}>
                    <RichTextEditor text={comment} />
                </div>
            )}
        </div>
    );
};

Review.propTypes = {
    /**
     * rating object
     */
    overallRating: PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.number,
    }),
    /**
     * review mention time
     */
    mentionTime: PropTypes.number,
    /**
     * review text
     */
    comment: PropTypes.string,
};

export default Review;
